import { createFileRoute } from '@tanstack/react-router';
import { Heading } from 'components/Heading';
import { RichTextContent } from 'components/RichTextContent';
import { requireGameLoaded } from 'engine/api';
import { useStore } from 'engine/store';
import type { FC } from 'react';
import { MobileScreen } from 'components/MobileScreen';

export const Route = createFileRoute('/help')({
	component: RouteComponent,
	beforeLoad: requireGameLoaded,
});

function RouteComponent() {
	const game = useStore((s) => s.game)!;

	return <HelpView help={game.help ?? ''} />;
}

const HelpView: FC<{ help: string }> = ({ help }) => {
	return (
		<MobileScreen className="flex flex-col gap-6">
			<Heading mode="primary">{__`Help`}</Heading>
			<RichTextContent content={help} />
		</MobileScreen>
	);
};
